import {Editor, Element} from "../../../../../../../pkg/slate.js";
export const isList = (node) => !Editor.isEditor(node) && Element.isElement(node) && (node.type === "ul" || node.type === "ol");
